import {
  FETCH_BRAND_AFFINITY_BRANDS_REPORT,
  FETCH_BRAND_AFFINITY_CATEGORIES_REPORT,
  FETCH_BRAND_AFFINITY_TOP_TOIS_REPORT,
  FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT,
  FETCH_BRAND_AFFINITY_ORGANISATION_OPTIONS,
  FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS,
  FETCH_BRAND_AFFINITY_SUMMARYCARD,
  SET_BRAND_AFFINITY_TOP_POIS_ORGANISATION_OPTION,
  SET_BRAND_AFFINITY_TOP_POIS_SUBCATEGORIES_OPTION,
  DOWNLOAD_BRAND_AFFINITY_INSIGHTS,
  SELECT_BRAND_AFFINITY_TIME_PERIOD,
  CLEAR_BRAND_AFFINITY_TOP_POI_OPTIONS
} from '../constants';


export const fetchBrandAffinityBrandsReport = () => ({
  type: FETCH_BRAND_AFFINITY_BRANDS_REPORT,
});

export const fetchBrandAffinityCategoriesReport = () => ({
  type: FETCH_BRAND_AFFINITY_CATEGORIES_REPORT,
});

export const fetchBrandAffinityTopPoisReport = () => ({
  type: FETCH_BRAND_AFFINITY_TOP_TOIS_REPORT,
});

export const fetchCategoryAffinityTopPoisReport = () => ({
  type: FETCH_CATEGORY_AFFINITY_TOP_TOIS_REPORT,
});


export const fetchBrandAffinityOrganisationOptions = () => ({
  type: FETCH_BRAND_AFFINITY_ORGANISATION_OPTIONS,
});

export const fetchBrandAffinitySubcategoriesOptions = () => ({
  type: FETCH_BRAND_AFFINITY_SUBCATEGORIES_OPTIONS,
});

export const  setBrandAffinityTopPoisOrganisationOption = option => ({
  type: SET_BRAND_AFFINITY_TOP_POIS_ORGANISATION_OPTION,
  option,
});

export const  setBrandAffinityTopPoisSubcategoriesOption = option => ({
  type: SET_BRAND_AFFINITY_TOP_POIS_SUBCATEGORIES_OPTION,
  option,
});

export const downloadBrandAffinity  = (csvType,reportType, fileName) => ({
  type: DOWNLOAD_BRAND_AFFINITY_INSIGHTS,
  csvType,
  reportType,
  fileName
});

export const selectBrandAffinityTimePeriod = selectedPeriod => ({
  type: SELECT_BRAND_AFFINITY_TIME_PERIOD,
  selectedPeriod,
});

export const fetchBrandAffinitySummaryCard = () => ({
  type: FETCH_BRAND_AFFINITY_SUMMARYCARD,
});

export const clearBrandAffinityTopPoiOptions = () =>({
  type: CLEAR_BRAND_AFFINITY_TOP_POI_OPTIONS,
})


